import { render } from "./DeleteContract.vue?vue&type=template&id=06a9c6d1"
import script from "./DeleteContract.vue?vue&type=script&lang=js"
export * from "./DeleteContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__